import { useCallback } from "react";
import { Modal } from "@/components/Modal/Modal";
import { ModalFooter } from "@/components/Modal/ModalFooter";
import { AppText } from "@/components/Text/AppText";
import { useAppDispatch, useAppSelector } from "@/hooks/types";
import { getIsModalOpen, getModalProps } from "@/store/modal/selectors";
import { closeModal } from "@/store/modal/slice";
import { ModalTypes } from "@/types/modal";

interface ConfirmModalProps {
    title: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    onConfirm: () => void;
}

export const ConfirmModal = () => {
    const isOpen = useAppSelector(getIsModalOpen(ModalTypes.CONFIRM));
    const modalProps = useAppSelector(
        getModalProps(ModalTypes.CONFIRM),
    ) as ConfirmModalProps;
    const dispatch = useAppDispatch();

    const handleCancel = useCallback(() => {
        dispatch(closeModal(ModalTypes.CONFIRM));
    }, [dispatch]);

    return (
        <Modal
            modalType={ModalTypes.CONFIRM}
            open={isOpen}
            title={modalProps?.title}
            width="md"
            footer={
                <ModalFooter
                    primaryActionText={modalProps?.confirmLabel || "Confirm"}
                    primaryActionOnClick={modalProps?.onConfirm}
                    secondaryActionText={modalProps?.cancelLabel || "Cancel"}
                    secondaryActionOnClick={handleCancel}
                    primaryActionColor="red"
                />
            }
        >
            <div className="flex flex-col gap-6">
                <AppText
                    variant="regular"
                    className="text-neutral-700"
                >
                    {modalProps?.message}
                </AppText>
            </div>
        </Modal>
    );
};
